var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 4001,
    height: 2001,
    viewBox: "0 0 4001 2001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 4000.21875 805.261719 L 3997.839844 1200.652344 L 2197.949219 1197.742188 L 2197.949219 2000.660156 L 1799.121094 2000.660156 L 1799.121094 1197.097656 L 0.472656 1194.195312 L 0.472656 798.800781 L 1799.121094 801.699219 L 1799.121094 0.789062 L 2197.949219 0.789062 L 2197.949219 802.339844 L 4000.21875 805.261719 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.16,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 2.61313,
    d: "M 40002.1875 11957.382812 L 39978.398438 8003.476562 L 21979.492188 8032.578125 L 21979.492188 3.398438 L 17991.210938 3.398438 L 17991.210938 8039.023438 L 4.726562 8068.046875 L 4.726562 12021.992188 L 17991.210938 11993.007812 L 17991.210938 20002.109375 L 21979.492188 20002.109375 L 21979.492188 11986.601562 Z M 40002.1875 11957.382812 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 2001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 0.472656 160.871094 L 1013.238281 660.800781 L 1329.160156 660.800781 L 0.472656 0.789062 L 0.472656 160.871094 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 0.472656 2000.660156 L 1330.898438 1332.578125 L 1631.199219 1332.578125 L 304.136719 2000.660156 L 0.472656 2000.660156 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 4000.46875 2000.660156 L 2660.820312 1329.105469 L 2968.058594 1329.105469 L 4000.429688 1851.578125 L 4000.46875 2000.660156 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 3689.941406 0.789062 L 2356.800781 671.21875 L 2669.25 671.21875 L 4000.21875 0.789062 L 3689.941406 0.789062 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 0.472656 225.96875 L 886.527344 670.351562 L 0.472656 670.351562 Z M 0.472656 225.96875 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 0.472656 1773.039062 L 886.527344 1328.660156 L 0.472656 1328.660156 Z M 0.472656 1773.039062 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 4000.230469 222.800781 L 3114.171875 667.179688 L 4000.230469 667.179688 Z M 4000.230469 222.800781 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 4000.230469 1779.132812 L 3114.171875 1334.753906 L 4000.230469 1334.753906 Z M 4000.230469 1779.132812 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 3549.960938 0.800781 L 2334.859375 616.820312 L 2334.859375 0.800781 Z M 3549.960938 0.800781 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 449.65625 0.800781 L 1664.761719 616.820312 L 1664.761719 0.800781 Z M 449.65625 0.800781 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 449.222656 2000.660156 L 1664.320312 1384.632812 L 1664.320312 2000.660156 Z M 449.222656 2000.660156 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 0%, 54.492188%)",
    fillOpacity: 1,
    d: "M 3549.800781 2000.660156 L 2334.699219 1384.632812 L 2334.699219 2000.660156 Z M 3549.800781 2000.660156 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 0.472656 798.800781 L 1799.121094 798.800781 L 1799.121094 0.789062 L 1664.761719 0.789062 L 1664.761719 616.820312 L 449.65625 0.800781 L 0.472656 0.800781 L 1329.160156 660.800781 L 1013.238281 660.800781 L 0.472656 160.871094 L 0.472656 225.96875 L 886.527344 670.351562 L 0.472656 670.351562 C 0.472656 670.351562 0.472656 798.800781 0.472656 798.800781 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.16,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 100%, 100%)",
    strokeOpacity: 1,
    strokeMiterlimit: 2.61313,
    d: "M 4.726562 12021.992188 L 17991.210938 12021.992188 L 17991.210938 20002.109375 L 16647.617188 20002.109375 L 16647.617188 13841.796875 L 4496.5625 20001.992188 L 4.726562 20001.992188 L 13291.601562 13401.992188 L 10132.382812 13401.992188 L 4.726562 18401.289062 L 4.726562 17750.3125 L 8865.273438 13306.484375 L 4.726562 13306.484375 C 4.726562 13306.484375 4.726562 12021.992188 4.726562 12021.992188 Z M 4.726562 12021.992188 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 2001)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 2197.949219 0.789062 L 2197.949219 802.339844 L 4000.21875 805.261719 L 4000.230469 667.179688 L 3114.171875 667.179688 L 4000.230469 222.800781 L 4000.230469 0.789062 L 2669.25 671.21875 L 2356.800781 671.21875 L 3689.941406 0.789062 L 3549.960938 0.789062 L 2334.859375 616.820312 L 2334.859375 0.800781 C 2334.859375 0.800781 2197.949219 0.800781 2197.949219 0.789062 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.16,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 100%, 100%)",
    strokeOpacity: 1,
    strokeMiterlimit: 2.61313,
    d: "M 21979.492188 20002.109375 L 21979.492188 11986.601562 L 40002.1875 11957.382812 L 40002.304688 13338.203125 L 31141.71875 13338.203125 L 40002.304688 17781.992188 L 40002.304688 20002.109375 L 26692.5 13297.8125 L 23568.007812 13297.8125 L 36899.414062 20002.109375 L 35499.609375 20002.109375 L 23348.59375 13841.796875 L 23348.59375 20001.992188 C 23348.59375 20001.992188 21979.492188 20001.992188 21979.492188 20002.109375 Z M 21979.492188 20002.109375 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 2001)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 0.472656 1194.195312 L 1799.121094 1194.195312 L 1799.121094 2000.660156 L 1664.320312 2000.660156 L 1664.320312 1384.632812 L 449.21875 2000.660156 L 304.136719 2000.660156 L 1631.199219 1332.578125 L 1330.898438 1332.578125 L 0.472656 2000.660156 L 0.472656 1773.039062 L 886.527344 1328.660156 L 0.472656 1328.660156 L 0.472656 1194.195312 "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.16,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 100%, 100%)",
    strokeOpacity: 1,
    strokeMiterlimit: 2.61313,
    d: "M 4.726562 8068.046875 L 17991.210938 8068.046875 L 17991.210938 3.398438 L 16643.203125 3.398438 L 16643.203125 6163.671875 L 4492.1875 3.398438 L 3041.367188 3.398438 L 16311.992188 6684.21875 L 13308.984375 6684.21875 L 4.726562 3.398438 L 4.726562 2279.609375 L 8865.273438 6723.398438 L 4.726562 6723.398438 Z M 4.726562 8068.046875 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 2001)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 3997.628906 1200.835938 L 2197.949219 1197.742188 L 2197.949219 2000.660156 L 2334.699219 2000.660156 L 2334.699219 1384.632812 L 3549.800781 2000.660156 L 4000.390625 2000.71875 L 2660.570312 1329.105469 L 2967.808594 1329.105469 L 4000.21875 1851.601562 L 4000.21875 1779.132812 L 3114.171875 1334.753906 L 3997.140625 1334.753906 L 3997.628906 1200.835938 "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.16,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 100%, 100%)",
    strokeOpacity: 1,
    strokeMiterlimit: 2.61313,
    d: "M 39976.289062 8001.640625 L 21979.492188 8032.578125 L 21979.492188 3.398438 L 23346.992188 3.398438 L 23346.992188 6163.671875 L 35498.007812 3.398438 L 40003.90625 2.8125 L 26605.703125 6718.945312 L 29678.085938 6718.945312 L 40002.1875 1493.984375 L 40002.1875 2218.671875 L 31141.71875 6662.460938 L 39971.40625 6662.460938 Z M 39976.289062 8001.640625 ",
    transform: "matrix(0.1, 0, 0, -0.1, 0, 2001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/gbFlag.f953cc1d77b0aca50c50b97905c012ac.svg";
export { ForwardRef as ReactComponent };